export default __webpack_public_path__ + "static/assets/med_x_ointment_mask.90c05f3a.png";